function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin, PendingActions } from '@ckeditor/ckeditor5-core/dist/index.js';
import { ObservableMixin, Collection, logWarning, uid, CKEditorError } from '@ckeditor/ckeditor5-utils/dist/index.js';
/**
 * Wrapper over the native `FileReader`.
 */

var FileReader = /*#__PURE__*/function (_ObservableMixin) {
  _inherits(FileReader, _ObservableMixin);

  var _super = _createSuper(FileReader);

  /**
  * Instance of native FileReader.
  */

  /**
  * Holds the data of an already loaded file. The file must be first loaded
  * by using {@link module:upload/filereader~FileReader#read `read()`}.
  */

  /**
  * Creates an instance of the FileReader.
  */
  function FileReader() {
    var _this;

    _classCallCheck(this, FileReader);

    _this = _super.call(this);
    _this.total = void 0;
    _this._reader = void 0;
    _this._data = void 0;
    var reader = new window.FileReader();
    _this._reader = reader;
    _this._data = undefined;

    _this.set('loaded', 0);

    reader.onprogress = function (evt) {
      _this.loaded = evt.loaded;
    };

    return _this;
  }
  /**
  * Returns error that occurred during file reading.
  */


  _createClass(FileReader, [{
    key: "error",
    get: function get() {
      return this._reader.error;
    }
    /**
    * Holds the data of an already loaded file. The file must be first loaded
    * by using {@link module:upload/filereader~FileReader#read `read()`}.
    */

  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
    /**
    * Reads the provided file.
    *
    * @param file Native File object.
    * @returns Returns a promise that will be resolved with file's content.
    * The promise will be rejected in case of an error or when the reading process is aborted.
    */

  }, {
    key: "read",
    value: function read(file) {
      var _this2 = this;

      var reader = this._reader;
      this.total = file.size;
      return new Promise(function (resolve, reject) {
        reader.onload = function () {
          var result = reader.result;
          _this2._data = result;
          resolve(result);
        };

        reader.onerror = function () {
          reject('error');
        };

        reader.onabort = function () {
          reject('aborted');
        };

        _this2._reader.readAsDataURL(file);
      });
    }
    /**
    * Aborts file reader.
    */

  }, {
    key: "abort",
    value: function abort() {
      this._reader.abort();
    }
  }]);

  return FileReader;
}( /* #__PURE__ */ObservableMixin());
/**
 * File repository plugin. A central point for managing file upload.
 *
 * To use it, first you need an upload adapter. Upload adapter's job is to handle communication with the server
 * (sending the file and handling server's response). You can use one of the existing plugins introducing upload adapters
 * (e.g. {@link module:easy-image/cloudservicesuploadadapter~CloudServicesUploadAdapter} or
 * {@link module:adapter-ckfinder/uploadadapter~CKFinderUploadAdapter}) or write your own one – see
 * the {@glink framework/deep-dive/upload-adapter Custom image upload adapter deep-dive} guide.
 *
 * Then, you can use {@link module:upload/filerepository~FileRepository#createLoader `createLoader()`} and the returned
 * {@link module:upload/filerepository~FileLoader} instance to load and upload files.
 */


var FileRepository = /*#__PURE__*/function (_Plugin) {
  _inherits(FileRepository, _Plugin);

  var _super2 = _createSuper(FileRepository);

  function FileRepository() {
    var _this3;

    _classCallCheck(this, FileRepository);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _this3.loaders = new Collection();
    _this3._loadersMap = new Map();
    _this3._pendingAction = null;
    return _this3;
  }
  /**
  * Collection of loaders associated with this repository.
  */

  /**
  * Loaders mappings used to retrieve loaders references.
  */

  /**
  * Reference to a pending action registered in a {@link module:core/pendingactions~PendingActions} plugin
  * while upload is in progress. When there is no upload then value is `null`.
  */


  _createClass(FileRepository, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this4 = this;

      // Keeps upload in a sync with pending actions.
      this.loaders.on('change', function () {
        return _this4._updatePendingAction();
      });
      this.set('uploaded', 0);
      this.set('uploadTotal', null);
      this.bind('uploadedPercent').to(this, 'uploaded', this, 'uploadTotal', function (uploaded, total) {
        return total ? uploaded / total * 100 : 0;
      });
    }
    /**
    * Returns the loader associated with specified file or promise.
    *
    * To get loader by id use `fileRepository.loaders.get( id )`.
    *
    * @param fileOrPromise Native file or promise handle.
    */

  }, {
    key: "getLoader",
    value: function getLoader(fileOrPromise) {
      return this._loadersMap.get(fileOrPromise) || null;
    }
    /**
    * Creates a loader instance for the given file.
    *
    * Requires {@link #createUploadAdapter} factory to be defined.
    *
    * @param fileOrPromise Native File object or native Promise object which resolves to a File.
    */

  }, {
    key: "createLoader",
    value: function createLoader(fileOrPromise) {
      var _this5 = this;

      if (!this.createUploadAdapter) {
        /**
        * You need to enable an upload adapter in order to be able to upload files.
        *
        * This warning shows up when {@link module:upload/filerepository~FileRepository} is being used
        * without {@link module:upload/filerepository~FileRepository#createUploadAdapter defining an upload adapter}.
        *
        * **If you see this warning when using one of the {@glink getting-started/legacy/installation-methods/predefined-builds
        * CKEditor 5 Builds}**
        * it means that you did not configure any of the upload adapters available by default in those builds.
        *
        * Predefined builds are a deprecated solution and we strongly advise
        * {@glink updating/nim-migration/migration-to-new-installation-methods migrating to new installation methods}.
        *
        * See the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn which upload
        * adapters are available in the builds and how to configure them.
        *
        * Otherwise, if you see this warning, there is a chance that you enabled
        * a feature like {@link module:image/imageupload~ImageUpload},
        * or {@link module:image/imageupload/imageuploadui~ImageUploadUI} but you did not enable any upload adapter.
        * You can choose one of the existing upload adapters listed in the
        * {@glink features/images/image-upload/image-upload "Image upload overview"}.
        *
        * You can also implement your {@glink framework/deep-dive/upload-adapter own image upload adapter}.
        *
        * @error filerepository-no-upload-adapter
        */
        logWarning('filerepository-no-upload-adapter');
        return null;
      }

      var loader = new FileLoader(Promise.resolve(fileOrPromise), this.createUploadAdapter);
      this.loaders.add(loader);

      this._loadersMap.set(fileOrPromise, loader); // Store also file => loader mapping so loader can be retrieved by file instance returned upon Promise resolution.


      if (fileOrPromise instanceof Promise) {
        loader.file.then(function (file) {
          _this5._loadersMap.set(file, loader);
        }) // Every then() must have a catch().
        // File loader state (and rejections) are handled in read() and upload().
        // Also, see the "does not swallow the file promise rejection" test.
        .catch(function () {});
      }

      loader.on('change:uploaded', function () {
        var aggregatedUploaded = 0;

        var _iterator = _createForOfIteratorHelper(_this5.loaders),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _loader = _step.value;
            aggregatedUploaded += _loader.uploaded;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this5.uploaded = aggregatedUploaded;
      });
      loader.on('change:uploadTotal', function () {
        var aggregatedTotal = 0;

        var _iterator2 = _createForOfIteratorHelper(_this5.loaders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _loader2 = _step2.value;

            if (_loader2.uploadTotal) {
              aggregatedTotal += _loader2.uploadTotal;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _this5.uploadTotal = aggregatedTotal;
      });
      return loader;
    }
    /**
    * Destroys the given loader.
    *
    * @param fileOrPromiseOrLoader File or Promise associated with that loader or loader itself.
    */

  }, {
    key: "destroyLoader",
    value: function destroyLoader(fileOrPromiseOrLoader) {
      var _this6 = this;

      var loader = fileOrPromiseOrLoader instanceof FileLoader ? fileOrPromiseOrLoader : this.getLoader(fileOrPromiseOrLoader);

      loader._destroy();

      this.loaders.remove(loader);

      this._loadersMap.forEach(function (value, key) {
        if (value === loader) {
          _this6._loadersMap.delete(key);
        }
      });
    }
    /**
    * Registers or deregisters pending action bound with upload progress.
    */

  }, {
    key: "_updatePendingAction",
    value: function _updatePendingAction() {
      var pendingActions = this.editor.plugins.get(PendingActions);

      if (this.loaders.length) {
        if (!this._pendingAction) {
          var t = this.editor.t;

          var getMessage = function getMessage(value) {
            return "".concat(t('Upload in progress'), " ").concat(parseInt(value), "%.");
          };

          this._pendingAction = pendingActions.add(getMessage(this.uploadedPercent));

          this._pendingAction.bind('message').to(this, 'uploadedPercent', getMessage);
        }
      } else {
        pendingActions.remove(this._pendingAction);
        this._pendingAction = null;
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'FileRepository';
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "requires",
    get: function get() {
      return [PendingActions];
    }
  }]);

  return FileRepository;
}(Plugin);
/**
 * File loader class.
 *
 * It is used to control the process of reading the file and uploading it using the specified upload adapter.
 */


var FileLoader = /*#__PURE__*/function (_ObservableMixin2) {
  _inherits(FileLoader, _ObservableMixin2);

  var _super3 = _createSuper(FileLoader);

  /**
  * Unique id of FileLoader instance.
  *
  * @readonly
  */

  /**
  * Additional wrapper over the initial file promise passed to this loader.
  */

  /**
  * Adapter instance associated with this file loader.
  */

  /**
  * FileReader used by FileLoader.
  */

  /**
  * Creates a new instance of `FileLoader`.
  *
  * @param filePromise A promise which resolves to a file instance.
  * @param uploadAdapterCreator The function which returns {@link module:upload/filerepository~UploadAdapter} instance.
  */
  function FileLoader(filePromise, uploadAdapterCreator) {
    var _this7;

    _classCallCheck(this, FileLoader);

    _this7 = _super3.call(this);
    _this7.id = void 0;
    _this7._filePromiseWrapper = void 0;
    _this7._adapter = void 0;
    _this7._reader = void 0;
    _this7.id = uid();
    _this7._filePromiseWrapper = _this7._createFilePromiseWrapper(filePromise);
    _this7._adapter = uploadAdapterCreator(_assertThisInitialized(_this7));
    _this7._reader = new FileReader();

    _this7.set('status', 'idle');

    _this7.set('uploaded', 0);

    _this7.set('uploadTotal', null);

    _this7.bind('uploadedPercent').to(_assertThisInitialized(_this7), 'uploaded', _assertThisInitialized(_this7), 'uploadTotal', function (uploaded, total) {
      return total ? uploaded / total * 100 : 0;
    });

    _this7.set('uploadResponse', null);

    return _this7;
  }
  /**
  * A `Promise` which resolves to a `File` instance associated with this file loader.
  */


  _createClass(FileLoader, [{
    key: "file",
    get: function get() {
      var _this8 = this;

      if (!this._filePromiseWrapper) {
        // Loader was destroyed, return promise which resolves to null.
        return Promise.resolve(null);
      } else {
        // The `this._filePromiseWrapper.promise` is chained and not simply returned to handle a case when:
        //
        //		* The `loader.file.then( ... )` is called by external code (returned promise is pending).
        //		* Then `loader._destroy()` is called (call is synchronous) which destroys the `loader`.
        //		* Promise returned by the first `loader.file.then( ... )` call is resolved.
        //
        // Returning `this._filePromiseWrapper.promise` will still resolve to a `File` instance so there
        // is an additional check needed in the chain to see if `loader` was destroyed in the meantime.
        return this._filePromiseWrapper.promise.then(function (file) {
          return _this8._filePromiseWrapper ? file : null;
        });
      }
    }
    /**
    * Returns the file data. To read its data, you need for first load the file
    * by using the {@link module:upload/filerepository~FileLoader#read `read()`} method.
    */

  }, {
    key: "data",
    get: function get() {
      return this._reader.data;
    }
    /**
    * Reads file using {@link module:upload/filereader~FileReader}.
    *
    * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-read-wrong-status` when status
    * is different than `idle`.
    *
    * Example usage:
    *
    * ```ts
    * fileLoader.read()
    * 	.then( data => { ... } )
    * 	.catch( err => {
    * 		if ( err === 'aborted' ) {
    * 			console.log( 'Reading aborted.' );
    * 		} else {
    * 			console.log( 'Reading error.', err );
    * 		}
    * 	} );
    * ```
    *
    * @returns Returns promise that will be resolved with read data. Promise will be rejected if error
    * occurs or if read process is aborted.
    */

  }, {
    key: "read",
    value: function read() {
      var _this9 = this;

      if (this.status != 'idle') {
        /**
        * You cannot call read if the status is different than idle.
        *
        * @error filerepository-read-wrong-status
        */
        throw new CKEditorError('filerepository-read-wrong-status', this);
      }

      this.status = 'reading';
      return this.file.then(function (file) {
        return _this9._reader.read(file);
      }).then(function (data) {
        // Edge case: reader was aborted after file was read - double check for proper status.
        // It can happen when image was deleted during its upload.
        if (_this9.status !== 'reading') {
          throw _this9.status;
        }

        _this9.status = 'idle';
        return data;
      }).catch(function (err) {
        if (err === 'aborted') {
          _this9.status = 'aborted';
          throw 'aborted';
        }

        _this9.status = 'error';
        throw _this9._reader.error ? _this9._reader.error : err;
      });
    }
    /**
    * Reads file using the provided {@link module:upload/filerepository~UploadAdapter}.
    *
    * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-upload-wrong-status` when status
    * is different than `idle`.
    * Example usage:
    *
    * ```ts
    * fileLoader.upload()
    * 	.then( data => { ... } )
    * 	.catch( e => {
    * 		if ( e === 'aborted' ) {
    * 			console.log( 'Uploading aborted.' );
    * 		} else {
    * 			console.log( 'Uploading error.', e );
    * 		}
    * 	} );
    * ```
    *
    * @returns Returns promise that will be resolved with response data. Promise will be rejected if error
    * occurs or if read process is aborted.
    */

  }, {
    key: "upload",
    value: function upload() {
      var _this10 = this;

      if (this.status != 'idle') {
        /**
        * You cannot call upload if the status is different than idle.
        *
        * @error filerepository-upload-wrong-status
        */
        throw new CKEditorError('filerepository-upload-wrong-status', this);
      }

      this.status = 'uploading';
      return this.file.then(function () {
        return _this10._adapter.upload();
      }).then(function (data) {
        _this10.uploadResponse = data;
        _this10.status = 'idle';
        return data;
      }).catch(function (err) {
        if (_this10.status === 'aborted') {
          throw 'aborted';
        }

        _this10.status = 'error';
        throw err;
      });
    }
    /**
    * Aborts loading process.
    */

  }, {
    key: "abort",
    value: function abort() {
      var status = this.status;
      this.status = 'aborted';

      if (!this._filePromiseWrapper.isFulfilled) {
        // Edge case: file loader is aborted before read() is called
        // so it might happen that no one handled the rejection of this promise.
        // See https://github.com/ckeditor/ckeditor5-upload/pull/100
        this._filePromiseWrapper.promise.catch(function () {});

        this._filePromiseWrapper.rejecter('aborted');
      } else if (status == 'reading') {
        this._reader.abort();
      } else if (status == 'uploading' && this._adapter.abort) {
        this._adapter.abort();
      }

      this._destroy();
    }
    /**
    * Performs cleanup.
    *
    * @internal
    */

  }, {
    key: "_destroy",
    value: function _destroy() {
      this._filePromiseWrapper = undefined;
      this._reader = undefined;
      this._adapter = undefined;
      this.uploadResponse = undefined;
    }
    /**
    * Wraps a given file promise into another promise giving additional
    * control (resolving, rejecting, checking if fulfilled) over it.
    *
    * @param filePromise The initial file promise to be wrapped.
    */

  }, {
    key: "_createFilePromiseWrapper",
    value: function _createFilePromiseWrapper(filePromise) {
      var wrapper = {};
      wrapper.promise = new Promise(function (resolve, reject) {
        wrapper.rejecter = reject;
        wrapper.isFulfilled = false;
        filePromise.then(function (file) {
          wrapper.isFulfilled = true;
          resolve(file);
        }).catch(function (err) {
          wrapper.isFulfilled = true;
          reject(err);
        });
      });
      return wrapper;
    }
  }]);

  return FileLoader;
}( /* #__PURE__ */ObservableMixin());
/**
 * A plugin that converts images inserted into the editor into [Base64 strings](https://en.wikipedia.org/wiki/Base64)
 * in the {@glink getting-started/setup/getting-and-setting-data editor output}.
 *
 * This kind of image upload does not require server processing – images are stored with the rest of the text and
 * displayed by the web browser without additional requests.
 *
 * Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn about
 * other ways to upload images into CKEditor 5.
 */


var Base64UploadAdapter = /*#__PURE__*/function (_Plugin2) {
  _inherits(Base64UploadAdapter, _Plugin2);

  var _super4 = _createSuper(Base64UploadAdapter);

  function Base64UploadAdapter() {
    _classCallCheck(this, Base64UploadAdapter);

    return _super4.apply(this, arguments);
  }

  _createClass(Base64UploadAdapter, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      this.editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
        return new Adapter$1(loader);
      };
    }
  }], [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [FileRepository];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'Base64UploadAdapter';
    }
  }]);

  return Base64UploadAdapter;
}(Plugin);
/**
 * The upload adapter that converts images inserted into the editor into Base64 strings.
 */


var Adapter$1 = /*#__PURE__*/function () {
  /**
  * `FileLoader` instance to use during the upload.
  */

  /**
  * Creates a new adapter instance.
  */
  function Adapter(loader) {
    _classCallCheck(this, Adapter);

    this.loader = void 0;
    this.reader = void 0;
    this.loader = loader;
  }
  /**
  * Starts the upload process.
  *
  * @see module:upload/filerepository~UploadAdapter#upload
  */


  _createClass(Adapter, [{
    key: "upload",
    value: function upload() {
      var _this11 = this;

      return new Promise(function (resolve, reject) {
        var reader = _this11.reader = new window.FileReader();
        reader.addEventListener('load', function () {
          resolve({
            default: reader.result
          });
        });
        reader.addEventListener('error', function (err) {
          reject(err);
        });
        reader.addEventListener('abort', function () {
          reject();
        });

        _this11.loader.file.then(function (file) {
          reader.readAsDataURL(file);
        });
      });
    }
    /**
    * Aborts the upload process.
    *
    * @see module:upload/filerepository~UploadAdapter#abort
    */

  }, {
    key: "abort",
    value: function abort() {
      this.reader.abort();
    }
  }]);

  return Adapter;
}();
/**
 * The Simple upload adapter allows uploading images to an application running on your server using
 * the [`XMLHttpRequest`](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest) API with a
 * minimal {@link module:upload/uploadconfig~SimpleUploadConfig editor configuration}.
 *
 * ```ts
 * ClassicEditor
 * 	.create( document.querySelector( '#editor' ), {
 * 		simpleUpload: {
 * 			uploadUrl: 'http://example.com',
 * 			headers: {
 * 				...
 * 			}
 * 		}
 * 	} )
 * 	.then( ... )
 * 	.catch( ... );
 * ```
 *
 * See the {@glink features/images/image-upload/simple-upload-adapter "Simple upload adapter"} guide to learn how to
 * learn more about the feature (configuration, server–side requirements, etc.).
 *
 * Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn about
 * other ways to upload images into CKEditor 5.
 */


var SimpleUploadAdapter = /*#__PURE__*/function (_Plugin3) {
  _inherits(SimpleUploadAdapter, _Plugin3);

  var _super5 = _createSuper(SimpleUploadAdapter);

  function SimpleUploadAdapter() {
    _classCallCheck(this, SimpleUploadAdapter);

    return _super5.apply(this, arguments);
  }

  _createClass(SimpleUploadAdapter, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var options = this.editor.config.get('simpleUpload');

      if (!options) {
        return;
      }

      if (!options.uploadUrl) {
        /**
        * The {@link module:upload/uploadconfig~SimpleUploadConfig#uploadUrl `config.simpleUpload.uploadUrl`}
        * configuration required by the {@link module:upload/adapters/simpleuploadadapter~SimpleUploadAdapter `SimpleUploadAdapter`}
        * is missing. Make sure the correct URL is specified for the image upload to work properly.
        *
        * @error simple-upload-adapter-missing-uploadurl
        */
        logWarning('simple-upload-adapter-missing-uploadurl');
        return;
      }

      this.editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
        return new Adapter(loader, options);
      };
    }
  }], [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [FileRepository];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'SimpleUploadAdapter';
    }
  }]);

  return SimpleUploadAdapter;
}(Plugin);
/**
 * Upload adapter.
 */


var Adapter = /*#__PURE__*/function () {
  /**
  * FileLoader instance to use during the upload.
  */

  /**
  * The configuration of the adapter.
  */

  /**
  * Creates a new adapter instance.
  */
  function Adapter(loader, options) {
    _classCallCheck(this, Adapter);

    this.loader = void 0;
    this.options = void 0;
    this.xhr = void 0;
    this.loader = loader;
    this.options = options;
  }
  /**
  * Starts the upload process.
  *
  * @see module:upload/filerepository~UploadAdapter#upload
  */


  _createClass(Adapter, [{
    key: "upload",
    value: function upload() {
      var _this12 = this;

      return this.loader.file.then(function (file) {
        return new Promise(function (resolve, reject) {
          _this12._initRequest();

          _this12._initListeners(resolve, reject, file);

          _this12._sendRequest(file);
        });
      });
    }
    /**
    * Aborts the upload process.
    *
    * @see module:upload/filerepository~UploadAdapter#abort
    */

  }, {
    key: "abort",
    value: function abort() {
      if (this.xhr) {
        this.xhr.abort();
      }
    }
    /**
    * Initializes the `XMLHttpRequest` object using the URL specified as
    * {@link module:upload/uploadconfig~SimpleUploadConfig#uploadUrl `simpleUpload.uploadUrl`} in the editor's
    * configuration.
    */

  }, {
    key: "_initRequest",
    value: function _initRequest() {
      var xhr = this.xhr = new XMLHttpRequest();
      xhr.open('POST', this.options.uploadUrl, true);
      xhr.responseType = 'json';
    }
    /**
    * Initializes XMLHttpRequest listeners
    *
    * @param resolve Callback function to be called when the request is successful.
    * @param reject Callback function to be called when the request cannot be completed.
    * @param file Native File object.
    */

  }, {
    key: "_initListeners",
    value: function _initListeners(resolve, reject, file) {
      var xhr = this.xhr;
      var loader = this.loader;
      var genericErrorText = "Couldn't upload file: ".concat(file.name, ".");
      xhr.addEventListener('error', function () {
        return reject(genericErrorText);
      });
      xhr.addEventListener('abort', function () {
        return reject();
      });
      xhr.addEventListener('load', function () {
        var response = xhr.response;

        if (!response || response.error) {
          return reject(response && response.error && response.error.message ? response.error.message : genericErrorText);
        }

        var urls = response.url ? {
          default: response.url
        } : response.urls; // Resolve with the normalized `urls` property and pass the rest of the response
        // to allow customizing the behavior of features relying on the upload adapters.

        resolve(_objectSpread(_objectSpread({}, response), {}, {
          urls: urls
        }));
      }); // Upload progress when it is supported.

      /* istanbul ignore else -- @preserve */

      if (xhr.upload) {
        xhr.upload.addEventListener('progress', function (evt) {
          if (evt.lengthComputable) {
            loader.uploadTotal = evt.total;
            loader.uploaded = evt.loaded;
          }
        });
      }
    }
    /**
    * Prepares the data and sends the request.
    *
    * @param file File instance to be uploaded.
    */

  }, {
    key: "_sendRequest",
    value: function _sendRequest(file) {
      // Set headers if specified.
      var headers = this.options.headers || {}; // Use the withCredentials flag if specified.

      var withCredentials = this.options.withCredentials || false;

      for (var _i = 0, _Object$keys = Object.keys(headers); _i < _Object$keys.length; _i++) {
        var headerName = _Object$keys[_i];
        this.xhr.setRequestHeader(headerName, headers[headerName]);
      }

      this.xhr.withCredentials = withCredentials; // Prepare the form data.

      var data = new FormData();
      data.append('upload', file); // Send the request.

      this.xhr.send(data);
    }
  }]);

  return Adapter;
}();

export { Base64UploadAdapter, FileRepository, SimpleUploadAdapter };